import { lazy } from '../../shared/deployment';

export const FreshChatInit = lazy(() => import('./ui/FreshChatInit'));
export const FreshChatShow = lazy(() => import('./ui/FreshChatShow'));
export const FreshChatHide = lazy(() => import('./ui/FreshChatHide'));
